import { GetColumn } from '../../../types';

export type CreateCsvProps<T> = {
  /** Columns in the file. */
  columns: GetColumn<T, unknown>[];
  /** Items used for rows in the file. */
  items: T[];
};

/** Create a CSV file with the provided @see items in it. */
export function createCsv<T>({
  columns,
  items
}: CreateCsvProps<T>) {
  const titles = columns.map(({ label }) => {
    return encodeCell(label);
  }).join(',');
  const rows = items.map((item) => {
    return columns.map(({ getter }) => {
      return encodeCell(
        (typeof getter === 'function') ? getter(item) : item[getter]
      );
    });
  }).join('\n');

  return titles + '\n' + rows;
}

function encodeCell(cellValue: unknown): string {
  let encoded: string;
  if (cellValue == null) {
    encoded = '';
  } else if (typeof cellValue === 'string') {
    encoded = cellValue.replace(/"/g, '""');
  } else if (typeof cellValue === 'object') {
    encoded = JSON.stringify(cellValue).replace(/"/g, '""');
  } else {
    encoded = `${cellValue}`;
  }

  return `"${encoded}"`;
}
